import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import Loading from './common/Loading';
import LoggedOut from './common/LoggedOut';
import Dimmer from './common/Dimmer';
import Forbidden from './common/Forbidden';

var LoruleBody = function LoruleBody(_ref) {
  var authState = _ref.authState,
      defaultPath = _ref.defaultPath,
      loadingCustom = _ref.loadingCustom,
      loggedOutCustom = _ref.loggedOutCustom,
      routes = _ref.routes;
  var isAuthenticated = useIsAuthenticated();
  var dimmer;
  var body;
  var loadingComponent = loadingCustom || /*#__PURE__*/React.createElement(Loading, null);
  var loggedOutComponent = loggedOutCustom || /*#__PURE__*/React.createElement(LoggedOut, null);

  if (authState.authenticating) {
    dimmer = /*#__PURE__*/React.createElement(Dimmer, null);
    body = loadingComponent;
  } else if (!isAuthenticated) {
    body = loggedOutComponent;
  } else {
    body = /*#__PURE__*/React.createElement("div", {
      "data-testid": "loruleAppContent",
      id: "content"
    }, /*#__PURE__*/React.createElement(Switch, null, routes, defaultPath && /*#__PURE__*/React.createElement(Route, {
      exact: true,
      path: "/",
      render: function render() {
        return /*#__PURE__*/React.createElement(Redirect, {
          to: defaultPath
        });
      }
    }), /*#__PURE__*/React.createElement(Route, {
      path: "/logged-out",
      component: function component() {
        return loggedOutComponent;
      }
    }), /*#__PURE__*/React.createElement(Route, {
      component: Forbidden
    })));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, dimmer, body);
};

export default LoruleBody;